import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { FormControl, Grid, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '../services/KeycloakProvider';
import './Index.css';
import { HomePageCard } from './pages/HomePageCard';

export const Index = () => {
  const keycloak = useKeycloak();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || i18n.language || 'en');

  useEffect(() => {
    const storedLang = localStorage.getItem('language');
    if (storedLang && storedLang !== i18n.language) {
      i18n.changeLanguage(storedLang);
      setLanguage(storedLang);
    }
  }, [i18n]);

  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    const lang = event.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  if (keycloak.authenticated) {
    return <Navigate to={'/home'} />;
  }

  return (
    <div className='index' >
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '0' }}>
        <FormControl variant="standard" size="small">
          <Select
            value={language}
            onChange={handleLanguageChange}
            inputProps={{ 'aria-label': t('Select language') }}
          >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="es-419">Español</MenuItem>
          </Select>
        </FormControl>
      </div>

      <h1 className="index-logo-container" id='page-heading' role='heading' aria-level={1} tabIndex={-1}>
        <div className="index-logo">
          <a href="https://b2ai-voice.org">
            {/* @ts-expect-error fetchpriority is a valid HTML attribute not yet in React's types */}
            <img fetchpriority="high" decoding="async" src="assets/images/logo.svg" alt="B2Ai Voice Logo" />
          </a>
          <div className="index-logo-text">
            <Typography fontWeight={100}>{t('Voice as a Biomarker of Health')}</Typography>
          </div>
        </div>
      </h1>

      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <HomePageCard
            title={t('Register')}
            description={t('Create an account to participate in the B2Ai Voice Study.')}
            image="/assets/images/b2ai-register.jpg"
            imageAlt={t('Register as a new participant')}
            actions={[
              {
                label: t('Register'),
                route: '/register'
              }
            ]}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <HomePageCard
            title={t('Sign in')}
            description={t('Sign in with your account to B2Ai Voice.')}
            image="/assets/images/b2ai-signin.jpg"
            imageAlt={t('Sign in with your account to B2Ai Voice.')}
            actions={[
              {
                label: t('Sign in'),
                route: '/signin'
              }
            ]}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <HomePageCard
            title={t('Learn more')}
            description={t('Learn more about the B2Ai Voice Study.')}
            image="/assets/images/b2ai-learn-more.jpg"
            imageAlt={t('Go to b2ai-voice.org')}
            actions={[
              {
                label: t('Go to b2ai-voice.org'),
                route: 'https://b2ai-voice.org/'
              }
            ]}
          />
        </Grid>
      </Grid>
    </div>
  );
};

